<template>
  <section>
    <EditarAsistenciaAutoridad />
    <v-card>
      <v-card-text class="grey lighten-2 text--info">
        <v-layout wrap>
          <v-flex class="px-3">
            <v-btn
              icon
              color="primary"
              :to="`/registro-manual-asistencia-autoridad/listado/${id_persona}/`"
            >
              <v-icon>arrow_back</v-icon>
            </v-btn>
           
            <strong> 
              Editar solicitud de nuevo registro de asistencia manual
            </strong>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text>
          <v-form  v-model="valid" ref="form" lazy-validation>
          <v-container grid-list-md>
             <v-layout> 
                <v-flex md4 >
               <v-text-field
                  type="date"
                  v-model="form.fecha_desde"
                  label="Fecha inicio"
               
                  :rules="$validate(['required'])"
                  required
                />
              </v-flex>
         
              <v-flex md4 >
                <v-text-field
                  type="date"
                  v-model="form.fecha_hasta"
                  label="Fecha fin"
                
                  :rules="$validate(['required'])"
                  required
                />
              </v-flex>
            </v-layout>

            <v-layout>
               <v-flex md4 >
                <v-text-field
                  type="time"
                  label="Hora ingreso mañana :"
                  v-model="form.hora_ingreso_mañana"
                />
              </v-flex>
              
               <v-flex md4 >
                <v-text-field
                  type="time"
                  label="Hora salida mañana"
                  v-model="form.hora_salida_mañana"
               />
              </v-flex>
            </v-layout>
              <v-layout>
               <v-flex md4 >
                <v-text-field
                  type="time"
                  label="Hora ingreso tarde :"
                  v-model="form.hora_ingreso_tarde"
                />
              </v-flex>
              
               <v-flex md4 >
                <v-text-field
                  type="time"
                  label="Hora salida tarde"
                  v-model="form.hora_salida_tarde"
               />
              </v-flex>
            </v-layout>
                     <!-- para adjuntos obligatorios-->
            <p>
              <strong>Respaldo:</strong> Usted tiene un archivo cargado, si desea cambiar de archivo seleccione otro.
            </p>
            <v-layout>
                
              <v-flex
                md6
                 >
                <input
                  type="file"
                  @change="handleFileUpload2()"
                  ref="file"
                  accept="application/pdf"
                />
                <p class="red--text body-1" v-if="errors2.file">
                  *Debe seleccionar un archivo
                </p>

                <p class="red--text body-1" v-if="errors2.denied">
                  *Formato no admitido por el sistema
                </p>
              </v-flex>
              <!-- Editar archivo cargado -->
              <v-flex md6>
                <v-btn
                  color="orange"
                  icon
                  title="Guardar archivo"
                  @click.prevent="editarArchivo()"
                  >
                      <v-icon>save</v-icon>
                  </v-btn>
              </v-flex>
            </v-layout>

             <v-layout>
              <v-flex md4>
                <v-spacer></v-spacer>
                <v-btn
                  title="Registar"
                  color="success" block type="submit" :disabled="!valid" @click="save()">
                  <v-icon>arrow_downward</v-icon>
                  Registrar
                </v-btn>
              </v-flex>
            </v-layout>
          
          </v-container>
        </v-form>
          	<!-- Cuerpo del formulario -->
			<v-form
			
				v-model="valid"
			
				lazy-validation
				>
				   <v-card-text>
      <v-container>
        <h3 ><strong>Detalles del registro</strong></h3>
        <v-tooltip bottom>
          <v-btn
            color="primary"
            dark
          
            @click="seleccionarTodo()"
            slot="activator"
            ><v-icon dark>speaker_group</v-icon> Seleccionar todo</v-btn
          >
          <span>Seleccionar todo</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn
            color="primary"
            dark
            v-if="selected.length > 0"
            @click.native.stop="deseleccionarTodo()"
            slot="activator"
            ><v-icon dark>speaker_group</v-icon> Deseleccionar todo</v-btn
          >
          <span>Deseleccionar todo</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn
            v-if="selected.length > 0"
            color="red"
            dark
            @click="eliminarVarios()"
            @change="deseleccionarTodo()"
            slot="activator"
            ><v-icon dark>speaker_group</v-icon> Eliminar</v-btn
          >
          <span>Eliminar</span>
        </v-tooltip> 
			<v-layout v-if="registro_detalles.length !=0" >
				<v-flex xs12>
					<v-data-table
						:items="registro_detalles"
						class="elevation-1"
						hide-actions
						:headers="headers"
						>
						<template v-slot:items="props">
                    
								<td class="text-xs-center">{{ (props.item.fecha) }}</td>
								<td class="text-xs-center">{{ (props.item.ingreso_am)}}</td>
								<td class="text-xs-center">{{ props.item.salida_am }}</td>
								<td class="text-xs-center">{{ props.item.ingreso_pm }}</td> 
                <td class="text-xs-center">{{ props.item.salida_pm}}</td> 
                <td class="text-xs-center">{{ props.item.estado_detalle}}</td> 
                <td class="text-xs-center">
                  <v-btn
                     v-if="(props.item.id_estado_detalle==22 || props.item.id_estado_detalle==7 ||props.item.id_estado_detalle==16)"
                color="primary"
                icon
                title="Modificar registro"
                @click.prevent="editarRegistro(props.item)"
                >
                    <v-icon>edit</v-icon>
                </v-btn>

                <v-btn
                    v-if="(props.item.id_estado_detalle==22)"
                color="error"
                icon
                title="Eliminar registro"
                @click.prevent="eliminarRegistro(props.item)"
                >
                    <v-icon>delete</v-icon>
                </v-btn>
                <v-tooltip bottom  v-if="(props.item.id_estado_detalle==22)">
                <v-btn
                  v-if="!verifica(props.item.id_detalle)"
                  icon
                  slot="activator"
                  @click.native="getId(props.item.id_detalle)"
                  @change="getId(props.item.id_detalle)"
                >
                  <v-icon>check_box_outline_blank</v-icon>
                </v-btn>
                <v-btn
                  v-if="verifica(props.item.id_detalle)"
                  icon
                  slot="activator"
                  @click.native="getId(props.item.id_detalle)"
                  @change="getId(props.item.id_detalle)"
                >
                  <v-icon>done</v-icon>
                </v-btn>
              </v-tooltip>
                  <v-btn
                v-if="(props.item.id_estado_detalle==9)"
                color="warning"
                icon
                title="Habilitar registro"
                @click.prevent="habilitarRegistro(props.item)"
                >
                    <v-icon>done</v-icon>
                </v-btn>
            </td>
						</template>
                    </v-data-table>
				</v-flex>
			</v-layout>

           
					
          </v-container>
      </v-card-text> 
				<v-card-actions>
					<small class="error--text text-required">* Los campos son obligatorios</small>
					<v-spacer></v-spacer>
					<v-btn
						:to="`/registro-manual-asistencia-autoridad/listado/${id_persona}/`"
              >
						<v-icon>cancel</v-icon>CERRAR
					</v-btn>
					<!--<v-btn
						color="primary"
						type="submit"
						:loading="loading"
						:disabled="!valid">
						<v-icon dark>check</v-icon> {{$t('common.save') }}
					</v-btn>-->
				</v-card-actions>
			
        </v-form>
      </v-card-text>  
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import validate from "@/common/mixins/validate";
import EditarAsistenciaAutoridad from "./dialogs/EditarAsistenciaAutoridad";



export default {
  components: {},
  mixins: [validate, crud],
  //mixins: [crud],
  data() {
    return {
       url: "v_asistencia_manual",  
      form: {},
      valid: false,
      validated: 0,
      habilita_boton:false,
      registro_detalles:[],
      id_persona: this.$route.params.id_persona,
      id_cabecera:this.$route.params.id_cabecera,
      errors: {
        denied: false,
      },
      errors2: {
        file: false,

        denied: false,
      },
      loading: false,
      fecha_resultante: "",
      rol: [],
      selected:[],
      file: "",
      dataGraphql: `
        id_persona
        id_estado
        nro_doc
        nro_complemento
        item
        nombre
        unidad
        fecha_ingreso
        cargo
        id_cargo
        id_puesto
        id_item
        id_unidad
        id_movilidad
        estado
        es_autoridad
      `,
      filters: [
        
        {
          field: "nombre",
          label: "Nombres",
          type: "text",
          typeG: "String",
        },
        
        {
          field: "item",
          label: "Ítem",
          type: "number",
          typeG: "String",
        },
       
      ],
      initData: [
        {
          state: true,
          param: "id_estado",
          value: 1,
        },
      ],
          headers: [
        {
          text: "Fecha",
          sortable: false
        },
        {
          text: "Hora ingreso mañana",
          sortable: false
        },
        {
          text: "Hora salida mañana",
          sortable: false
        },
       {
          text: "Hora ingreso tarde",
          sortable: false
        },
        {
          text: "Hora salida tarde",
          sortable: false
        },
        {
          text: "Acciones",
          sortable: false
        }
      ],
    };
  },
  
  async mounted() {
    this.getPersonaId();
    this.cargaForm()
    this.cargarRegistroDetalle(this.id_cabecera)
    this.$bus.$on('closeDialog', async() => {
      this.updateList()
      await this.cargarRegistroDetalle(this.id_cabecera)
    })
  },
  methods: {
    async cargaForm(){
      try {
         let res = await this.$service.graphql({
          query: `
						query{
              vAsistenciaManualCabeceras(id:"${this.id_cabecera}"){
                rows{
                  id
                  id_persona
                  nombres
                  id_estado
                  estado
                  fecha_registro
                  ruta
                  fecha_inicio
                  fecha_fin
                  autoridad
                  
                }
              }
            }
					`
        });
                  // v-model="form.fecha_desde"
                  // v-model="form.fecha_hasta"
                  // v-model="form.hora_ingreso_mañana"
                  // v-model="form.hora_salida_mañana"
                  // v-model="form.hora_ingreso_tarde"
                  // v-model="form.hora_salida_tarde"
              
        res = res.vAsistenciaManualCabeceras.rows[0]
        if(res!=undefined){
          this.form={
            fecha_desde:res.fecha_inicio.split("/").reverse().join("-"),
            fecha_hasta:res.fecha_fin.split("/").reverse().join("-"),
            ruta_respaldo:res.ruta
          }
        }
        

      } catch (error) {
        
      }
    },
    verifica(id) {
      return this.selected.includes(id);
    },
    getId(id) {
      let sw = false;
      let index;
      for (let i = 0; i < this.selected.length; i++) {
        const element = this.selected[i];
        if (id == element) {
          sw = true;
          index = i;
          break;
        }
      }
      if (sw == true) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(id);
      }

      return sw;
    },
    async eliminarVarios(){
      try { this.$confirm("Esta seguro de eliminar los registros seleccionados?", async() => {

          let respuesta 
          let id_funcionario=parseInt(this.$storage.get("user").id_persona)
          let fecha = this.$moment(new Date()).format("YYYY-MM-DD");
          for (let j = 0; j < this.selected.length; j++) {
            const element = this.selected[j];
            let consulta=`SELECT control.fn_anula_asistencia_manual_detalle(${parseInt(element)},9,${id_funcionario},'${fecha}')`
          try {
            console.log(this.selected[j])
            respuesta = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta:"${consulta}"){
                  respuesta
                  }
                  }
                `,
            });
            respuesta = respuesta.runQuery.respuesta[0].fn_anula_asistencia_manual_detalle;
            let resps = respuesta.split("|");
            let correcto = resps[0];
            if (correcto == "1") {
              this.$message.success("Anulación exitosa.");
              await this.cargarRegistroDetalle(this.id_cabecera)
            } 
            else {
              this.$message.error(resps[1]);
            }
          } catch (error) {
            console.log(error);
          }
          }
         
            this.selected=[];
      });
      } catch (error) {
        console.log(error)
      }
    },
    async seleccionarTodo() {
      let lista_seleccion = [];
      let resp = await this.$service.graphql({
        query: `
        query{
              vAsistenciaManualDetalles(id_cabecera:${parseInt(this.id_cabecera)},id_estado_detalle:22){
                rows{
                  id_persona
                  ingreso_am
                  ingreso_pm
                  id_estado_detalle
                  id_estado_cabecera
                  fecha
                  salida_am
                  salida_pm
                  ruta
                  estado_detalle
                  estado_cabecera
                  id_detalle
                  id_cabecera
                  autoridad
                }
              }
            }
                `,
      });

      lista_seleccion = resp.vAsistenciaManualDetalles.rows;

      for (let j = 0; j < lista_seleccion.length; j++) {
        const element = lista_seleccion[j];

        let sw = false;
        for (let i = 0; i < this.selected.length; i++) {
          const element2 = this.selected[i];

          if (parseInt(element.id_detalle) == element2) {
            sw = true;
            break;
          }
        }
        if (!sw) {
          this.selected.push(element.id_detalle);
        }
      
      }
      console.log("nn",this.selected)
    },
    deseleccionarTodo() {
      this.selected = [];
    },
    async eliminarRegistro(item){
      if (this.selected.length>0) {
      await this.eliminarVarios()
    }else{
      this.$confirm("Está seguro de deshabilitar el registro?", async() => {

let respuesta 
let id_funcionario=parseInt(this.$storage.get("user").id_persona)
let fecha = this.$moment(new Date()).format("YYYY-MM-DD");
let consulta=`SELECT control.fn_anula_asistencia_manual_detalle(${parseInt(item.id_detalle)},9,${id_funcionario},'${fecha}')`
try {
  respuesta = await this.$service.graphql({
    query: `
      query{
        runQuery(consulta:"${consulta}"){
        respuesta
        }
        }
      `,
  });
  respuesta = respuesta.runQuery.respuesta[0].fn_anula_asistencia_manual_detalle;
  let resps = respuesta.split("|");
  let correcto = resps[0];
  if (correcto === "1") {
    this.$message.success("Anulación exitosa.");
    await this.cargarRegistroDetalle(this.id_cabecera)
  } 
  else {
    this.$message.error(resps[1]);
  }
} catch (error) {
  console.log(error);
}

});
    }
    },
    async habilitarRegistro(item){
      this.$confirm("Esta seguro de deshabilitar el registro?", async() => {
          // SELECT control.fn_anula_asistencia_manual_detalle(
          //   p_id_asistencia_manual_detalle integer, 
          //   p_id_estado integer, 
          //   p_id_funcionario integer, 
          //   p_fecha_actual date
          //   )
          let respuesta 
          let id_funcionario=parseInt(this.$storage.get("user").id_persona)
          let fecha = this.$moment(new Date()).format("YYYY-MM-DD");
          let consulta=`SELECT control.fn_anula_asistencia_manual_detalle(${parseInt(item.id_detalle)},22,${id_funcionario},'${fecha}')`
          try {
            respuesta = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta:"${consulta}"){
                  respuesta
                  }
                  }
                `,
            });
            respuesta = respuesta.runQuery.respuesta[0].fn_anula_asistencia_manual_detalle;
            let resps = respuesta.split("|");
            let correcto = resps[0];
            if (correcto === "1") {
              this.$message.success("Habilitación exitosa.");
              await this.cargarRegistroDetalle(this.id_cabecera)
            } 
            else {
              this.$message.error(resps[1]);
            }
          } catch (error) {
            console.log(error);
          }

      });
    },
    async editarRegistro(item){
      this.$bus.$emit("openDialogEditarAsistenciaAutoridad", item);
      await this.cargarRegistroDetalle(this.id_cabecera)
    },
    async cargarRegistroDetalle(id_cabecera){
      try {
         let res = await this.$service.graphql({
          query: `
						query{
              vAsistenciaManualDetalles(id_cabecera:${parseInt(id_cabecera)}){
                rows{
                  id_persona
                  ingreso_am
                  ingreso_pm
                  id_estado_detalle
                  id_estado_cabecera
                  fecha
                  salida_am
                  salida_pm
                  ruta
                  estado_detalle
                  estado_cabecera
                  id_detalle
                  id_cabecera
                  autoridad
                }
              }
            }
					`
        });
        this.registro_detalles=res.vAsistenciaManualDetalles.rows
        
      } catch (error) {
        
      }
    },
    close(){

    },
      async saveFile(){

      },
      eliminarDetalle(){

      },
    getPersonaId() {
      const user = this.$storage.get("user");
      return user.id_persona;
    },
  
    handleFileUpload() {
      if (this.$refs.file.value !== "") {
        const file = this.$refs.file.files[0];
        if (this.$refs.file.files[0].type.includes("application/pdf")) {
          this.errors.denied = false;
        } else {
          this.errors.denied = true;
        }
        this.file = file;
      }
    },
    handleFileUpload2() {

      if (this.$refs.file.value !== "") {
        const file = this.$refs.file.files[0];

        if (this.$refs.file.value === "") {
          this.errors2.file = true;
        } else {
          this.errors2.file = false;
        }
        if (this.$refs.file.files[0].type.includes("application/pdf")) {
          this.errors2.denied = false;
        } else {
          this.errors2.denied = true;
        }
        this.file = file;
      }
    },
    async editarArchivo(){
        if (this.$refs.file.value === "") {
          this.errors2.file = true;
          return this.errors2;
        } else {
          this.errors2.file = false;
        }
        if (this.errors2.denied) {
          return this.errors2;
        }
        let formData = new FormData();
        formData.append("file", this.file);
        let res = await this.$http.post(
          process.env.API_URL + "public/upload",
        formData
        );
        this.form.ruta_archivo = res.data;
        // SELECT control.fn_actualiza_asistencia_manual_archivo(
        //   p_id_asistencia_manual integer, 
        //   p_fecha_actual date, 
        //   p_id_funcionario integer, 
        //   p_ruta_archivo character varying
        //   )
        let data={
            fecha_actual:this.$moment(new Date()).format("YYYY-MM-DD"),
            ruta:this.form.ruta_archivo,
            id_funcionario:this.$storage.get("user").id,
            id_cabecera:parseInt(this.id_cabecera),
        }
        let respuesta 
          let consulta=`SELECT control.fn_actualiza_asistencia_manual_archivo(${data.id_cabecera},'${data.fecha_actual}',${data.id_funcionario},'${data.ruta}')`
          try {
            respuesta = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta:"${consulta}"){
                  respuesta
                  }
                  }
                `,
            });
          } catch (error) {
            console.log(error);
          }
          try {
            respuesta = respuesta.runQuery.respuesta[0].fn_actualiza_asistencia_manual_archivo;
            let resps = respuesta.split("|");
            let correcto = resps[0];
            if (correcto === "1") {
              this.$message.success("Registro exitoso.");
					} 
					else {
						this.$message.error(resps[1]);
					}
          } catch (error) {
            console.log(error);
          } 

    },
    async save () {
			if (this.$refs.form.validate()) {
        if (this.form.hora_ingreso_mañana || this.form.hora_ingreso_tarde || this.form.hora_salida_mañana || this.form.hora_salida_tarde) {
				this.loading = true
        let fecha = this.$moment(new Date()).format("YYYY-MM-DD");
        let resps = [];
        // if (this.$refs.file.value === "") {
        //   this.errors2.file = true;
        //   return this.errors2;
        // } else {
        //   this.errors2.file = false;
        // }
        // if (this.errors2.denied) {
        //   return this.errors2;
        // }  
				try {
        //obtener ruta del archivo
          
          if(this.form.hora_ingreso_mañana==undefined || !this.form.hora_ingreso_mañana){this.form.hora_ingreso_mañana='00:00'}
          if(this.form.hora_salida_mañana==undefined || !this.form.hora_salida_mañana){this.form.hora_salida_mañana='00:00'}
          if(this.form.hora_ingreso_tarde==undefined || !this.form.hora_ingreso_tarde){this.form.hora_ingreso_tarde='00:00'}
          if(this.form.hora_salida_tarde==undefined || !this.form.hora_salida_tarde){this.form.hora_salida_tarde='00:00'}
          if(this.$refs.file.value === ""){
            this.form.ruta_archivo=this.form.ruta_respaldo
          }
          else{
            let formData = new FormData();
            formData.append("file", this.file);
            let res = await this.$http.post(
              process.env.API_URL + "public/upload",
            formData
            );
            this.form.ruta_archivo = res.data;
          }
          
          let registro_cabecera={
            fecha_actual:this.$moment(new Date()).format("YYYY-MM-DD"),
            fecha_desde:this.form.fecha_desde,
            fecha_hasta:this.form.fecha_hasta,
            hora_salida_manana:this.form.hora_salida_mañana,
            hora_ingreso_manana:this.form.hora_ingreso_mañana,
            hora_salida_tarde:this.form.hora_salida_tarde,
            hora_ingreso_tarde:this.form.hora_ingreso_tarde,
            ruta:this.form.ruta_archivo,
            id_funcionario:this.$storage.get("user").id,
            id_persona:parseInt(this.$route.params.id_persona),
          }
        
          let respuesta 
          let consulta=`SELECT control.fn_actualiza_asistencia_manual(${parseInt(this.id_cabecera)},'${registro_cabecera.fecha_actual}',${registro_cabecera.id_persona},'${registro_cabecera.hora_ingreso_manana}','${registro_cabecera.hora_salida_manana}','${registro_cabecera.hora_ingreso_tarde}','${registro_cabecera.hora_salida_tarde}','${registro_cabecera.fecha_desde}','${registro_cabecera.fecha_hasta}',${registro_cabecera.id_funcionario},'${registro_cabecera.ruta}',1)`
          try {
    
            respuesta = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta:"${consulta}"){
                  respuesta
                  }
                  }
                `,
            });
          } catch (error) {
            console.log(error);
          }
          try {
            respuesta = respuesta.runQuery.respuesta[0].fn_actualiza_asistencia_manual;
            let resps = respuesta.split("|");
            let correcto = resps[0];
            if (correcto === "1") {
              this.id_cabecera=resps[1]
              await this.cargarRegistroDetalle(this.id_cabecera)
              this.habilita_boton=true
              this.$confirm("Registro exitoso.", () => {});
            } 
            else {
              this.$confirm(resps[1], () => {});
            }
          } catch (error) {
            console.log(error);
          } 
                
                  //registrar 
					/*	await this.$service.graphql({
							query: `
								mutation edit($id: ID!, $registro_manual_asistencia: EditRegistroManualAsistencia!){
									registroManualAsistenciaEdit(id: $id, registro_manual_asistencia: $registro_manual_asistencia){
										id
									}
								}
							`,
							variables: {
								id: id,
								registro_manual_asistencia: this.form
							}
						})*/
					
				} catch (error) {
					console.log(error)
				}

        } else {
          this.$message.warning("Debe ingresar al menos una hora");
        } 
			}
		}
    
  },
  components: {
    EditarAsistenciaAutoridad,
  },
};
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/admin/registro_manual_asistencia/EditarRegistroAsistenciaManualAutoridad.vue